<img class="my-3" [ngClass]="{ 'placeholder': !total }" src="{{path}}">
